import {gsap} from "gsap";
import {Game} from "../Game";
import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {GameModeNames} from "../server/GameModeNames";

export class MayhemSpinsRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.monstersWithNoLife.length === 4 && Game.model.data.mayhemSpin && !Game.model.data.brokeTheBank;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        controller.setSkipCallback();

        const featureTl: gsap.core.Timeline = gsap.timeline();

        Game.reelCorners.resetLifeOfAllCorners(1);

        if (Game.model.isMayHemAlreadyTriggered) {
            featureTl.add(Game.featureIntro.showMayhemReTriggerIntro(() => controller.finish()));
        } else {
            // Game.soundPlayer.fadeOutBGSound();
            featureTl.add(Game.featureIntro.showMayhemIntro(() => {
                Game.model.isMayHemAlreadyTriggered = true;
                controller.finish()
            }));
        }
    }
}